import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
// ScrollSmoother requires ScrollTrigger
import { CSSPlugin } from "gsap/CSSPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";
import { TextPlugin } from "gsap/TextPlugin";
import * as flipper from './flipper';

gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin,SplitText,TextPlugin);
const gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap;

const mm = gsapWithCSS.matchMedia();

const workFeature = document.querySelector(".workDetail__carousel");
const workDetail = document.querySelector("#js-workDetail-content");

if (workFeature && workDetail) {
  mm.add("(min-width: 1400px)", () => {
    const workScrollTrigger = ScrollTrigger.create({
      trigger: workFeature,
      start: "top 0%",
      endTrigger: workDetail,
      end: () => `bottom ${workFeature.offsetHeight}px`,
      invalidateOnRefresh: true,
      pin: true
    });

    const refreshWorkScrollTrigger = (event) => {
      if (event.detail?.carousel !== workFeature) {
        return;
      }

      window.requestAnimationFrame(() => {
        workScrollTrigger.refresh();
      });
    };

    window.addEventListener("work-carousel:heightchange", refreshWorkScrollTrigger);

    return () => {
      window.removeEventListener("work-carousel:heightchange", refreshWorkScrollTrigger);
      workScrollTrigger.kill();
    };
  });
}

const statsFeatureTrigger = document.querySelector("#statsFeature__trigger");

if (statsFeatureTrigger) {
  const tl = gsapWithCSS.timeline({
    scrollTrigger: {
      trigger: "#statsFeature__trigger",
      start: "top 80%",
      end: "top 10%",
      pin: false,
      // scrub: true,
      once: true,
      onLeave: self => {
        // let scroll = self.scroll() - (self.end - self.start);
        // self.kill();
        // self.scroll(scroll);
        tl.progress(1);
      },
    }
  });

  tl.to({}, { duration: 1 }).call(animateBoards, [], 0.2);

  function animateBoards() {
      flipper.boards();
  };
}
